module.exports = __webpack_public_path__ + "img/cm.88c35ff2.png";